
(() => {
  if(customElements.get('mv-cubeflex-extras')) return;
  class CubeFlexExtras extends HTMLElement {
    connectedCallback(){
      if(this.startup||this.abort)return;
      this.startup=requestAnimationFrame(()=>{this.startup=0;if(this.isConnected)this.initialize();});
    }
    initialize(){
      this.abort=new AbortController();
      const signal=this.abort.signal;
      const carousel=this.querySelector('.cfxe-recommendation-carousel');
      const cards=carousel?.querySelector('.cfxe-product-cards');
      const prev=carousel?.querySelector('.cfxe-recommendation-arrow--previous');
      const next=carousel?.querySelector('.cfxe-recommendation-arrow--next');
      if(cards){
        const update=()=>{
          if(prev)prev.disabled=cards.scrollLeft<=2;
          if(next)next.disabled=cards.scrollLeft+cards.clientWidth>=cards.scrollWidth-2;
        };
        const move=direction=>cards.scrollBy({left:direction*cards.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        prev?.addEventListener('click',()=>move(-1),{signal});
        next?.addEventListener('click',()=>move(1),{signal});
        cards.addEventListener('scroll',update,{passive:true,signal});
        if('ResizeObserver' in window){this.resize=new ResizeObserver(update);this.resize.observe(cards);}
        update();
      }
      const judgeSummary=this.querySelector('.cfxe-judge-summary');
      const originalSummary=this.querySelector('.cfxe-review-summary');
      if(judgeSummary&&originalSummary){
        const syncRating=()=>{
          const average=judgeSummary.querySelector('.jm-average-rating-display>.jm-cluster');
          if(!average){
            const widget=judgeSummary.querySelector('.jdgm-review-widget');
            const data=window.jdgm?.data?.reviewWidget?.[widget?.dataset.id];
            const histogram=data?.histogram;
            const rows=Array.isArray(histogram)?[...histogram].sort((a,b)=>b.rating-a.rating):[];
            const valid=rows.length===5&&rows.every((row,index)=>Number(row.rating)===5-index&&Number.isInteger(Number(row.frequency))&&Number(row.frequency)>=0);
            const sum=rows.reduce((total,row)=>total+Number(row.frequency),0);
            if(!data)return;
            judgeSummary.classList.add('cfxe-rating-enhanced','cfxe-fallback-enhanced');
            const fallbackSignature=`${widget?.dataset.id||''}:${data.average_rating||''}:${data.number_of_reviews||0}:${rows.map(row=>`${row.rating}:${row.frequency}`).join(',')}`;
            let overview=judgeSummary.querySelector('.cfxe-fallback-overview');
            if(overview?.dataset.signature===fallbackSignature)return;
            if(overview)overview.remove();
            overview=document.createElement('div');
            overview.className='cfxe-fallback-overview';
            overview.dataset.signature=fallbackSignature;
            const ratingColumn=document.createElement('div');
            ratingColumn.className='cfxe-fallback-rating';
            const ratingTop=document.createElement('div');
            ratingTop.className='cfxe-fallback-rating-top';
            const score=document.createElement('strong');
            score.className='cfxe-fallback-score';
            score.textContent=Number(data.average_rating||0).toFixed(1);
            const verified=document.createElement('span');
            verified.className='cfxe-fallback-verified';
            verified.textContent='✓ Verified';
            ratingTop.append(score,verified,originalSummary);
            ratingColumn.append(ratingTop);
            const medals=Array.isArray(data.product_medals)?data.product_medals.slice(0,2):[];
            if(medals.length){
              const medalRow=document.createElement('div');
              medalRow.className='cfxe-fallback-medals';
              medals.forEach(medal=>{
                if(!medal?.medal_image_url)return;
                const image=document.createElement('img');
                image.src=medal.medal_image_url;
                image.alt=medal.title||'Judge.me verification medal';
                image.loading='lazy';
                medalRow.append(image);
              });
              ratingColumn.append(medalRow);
            }
            if(valid&&sum===Number(data?.number_of_reviews)&&sum>0){
              const signature=rows.map(row=>`${row.rating}:${row.frequency}`).join(',');
              const list=document.createElement('ul');
              list.className='cfxe-rating-distribution';
              list.dataset.signature=signature;
              for(const row of rows){
                const item=document.createElement('li');
                const label=document.createElement('span');
                label.className='cfxe-rating-level';label.textContent=`${row.rating} `;
                const star=document.createElement('span');star.textContent='\u2605';star.setAttribute('aria-hidden','true');label.append(star);
                const track=document.createElement('span');track.className='cfxe-rating-track';track.setAttribute('aria-hidden','true');
                const fill=document.createElement('span');fill.style.width=`${Number(row.frequency)/sum*100}%`;track.append(fill);
                const frequency=document.createElement('span');frequency.className='cfxe-rating-frequency';frequency.textContent=String(row.frequency);
                item.append(label,track,frequency);list.append(item);
              }
              ratingColumn.append(list);
            }
            const reviewCta=judgeSummary.querySelector('template[data-cfxe-review-cta]');
            if(reviewCta)ratingColumn.append(reviewCta.content.cloneNode(true));
            overview.append(ratingColumn);
            const galleryItems=[];
            (Array.isArray(data.photo_gallery)?data.photo_gallery:[]).forEach(photo=>{
              (Array.isArray(photo.pictures_urls)?photo.pictures_urls:[]).forEach(picture=>{
                const source=picture.compact||picture.small||picture.original;
                if(source&&galleryItems.length<8)galleryItems.push({source:source,name:photo.reviewer_name||'Customer'});
              });
            });
            if(galleryItems.length){
              const media=document.createElement('div');
              media.className='cfxe-fallback-media';
              const caption=judgeSummary.querySelector('template[data-cfxe-media-caption]');
              if(caption)media.append(caption.content.cloneNode(true));
              const grid=document.createElement('div');
              grid.className='cfxe-fallback-media-grid';
              galleryItems.forEach(item=>{
                const link=document.createElement('a');
                link.href=item.source;link.target='_blank';link.rel='nofollow';
                const image=document.createElement('img');
                image.src=item.source;image.alt=`${item.name} review photo`;image.loading='lazy';image.decoding='async';
                link.append(image);grid.append(link);
              });
              media.append(grid);overview.append(media);
            }
            judgeSummary.append(overview);
            return;
          }
          const nativeTexts=[...average.children].filter(node=>node.classList.contains('jm-text'));
          const score=Number.parseFloat(nativeTexts[0]?.textContent);
          const count=nativeTexts[1]?.textContent.trim();
          if(!Number.isFinite(score)||score<0||score>5||!count)return;
          const stars=originalSummary.querySelector('.cfxe-review-summary-stars');
          const total=originalSummary.querySelector('.cfxe-review-summary-count');
          const fill=`${score/5*100}%`;
          if(stars&&stars.style.getPropertyValue('--rating-fill')!==fill)stars.style.setProperty('--rating-fill',fill);
          if(total&&total.textContent!==count)total.textContent=count;
          if(originalSummary.parentElement!==average)average.append(originalSummary);
          if(!judgeSummary.classList.contains('cfxe-rating-enhanced'))judgeSummary.classList.add('cfxe-rating-enhanced');
          const widget=judgeSummary.querySelector('.jdgm-review-widget');
          const data=window.jdgm?.data?.reviewWidget?.[widget?.dataset.id];
          const histogram=data?.histogram;
          const rows=Array.isArray(histogram)?[...histogram].sort((a,b)=>b.rating-a.rating):[];
          const valid=rows.length===5&&rows.every((row,index)=>Number(row.rating)===5-index&&Number.isInteger(Number(row.frequency))&&Number(row.frequency)>=0);
          const sum=rows.reduce((total,row)=>total+Number(row.frequency),0);
          if(valid&&sum===Number(data.number_of_reviews)&&sum>0){
            const signature=rows.map(row=>`${row.rating}:${row.frequency}`).join(',');
            let distribution=judgeSummary.querySelector('.cfxe-rating-distribution');
            if(!distribution||distribution.dataset.signature!==signature){
              const list=document.createElement('ul');
              list.className='cfxe-rating-distribution';
              list.dataset.signature=signature;
              for(const row of rows){
                const item=document.createElement('li');
                const label=document.createElement('span');
                label.className='cfxe-rating-level';label.textContent=`${row.rating} `;
                const star=document.createElement('span');star.textContent='\u2605';star.setAttribute('aria-hidden','true');label.append(star);
                const track=document.createElement('span');track.className='cfxe-rating-track';track.setAttribute('aria-hidden','true');
                const fill=document.createElement('span');fill.style.width=`${Number(row.frequency)/sum*100}%`;track.append(fill);
                const frequency=document.createElement('span');frequency.className='cfxe-rating-frequency';frequency.textContent=String(row.frequency);
                item.append(label,track,frequency);list.append(item);
              }
              if(distribution)distribution.replaceWith(list);else average.parentElement.parentElement.append(list);
            }
          }
          const gallery=judgeSummary.querySelector('.jm-media-preview');
          const caption=judgeSummary.querySelector('template[data-cfxe-media-caption]');
          if(gallery&&caption&&!gallery.querySelector('.cfxe-media-caption'))gallery.prepend(caption.content.cloneNode(true));
          const reviewCta=judgeSummary.querySelector('template[data-cfxe-review-cta]');
          const ratingColumn=average.parentElement?.parentElement;
          if(reviewCta&&ratingColumn&&!ratingColumn.querySelector('.cfxe-review-product-cta'))ratingColumn.append(reviewCta.content.cloneNode(true));
        };
        this.judgeObserver=new MutationObserver(syncRating);
        this.judgeObserver.observe(judgeSummary,{childList:true,subtree:true,characterData:true});
        syncRating();
      }
      this.dialog=this.querySelector('.cfxe-image-dialog');
      const large=this.dialog?.querySelector('.cfxe-image-large');
      const close=this.dialog?.querySelector('.cfxe-image-close');
      this.querySelectorAll('.cfxe-review-images button').forEach(button=>{
        const image=button.querySelector('img');
        if(!image)return;
        if(!button.hasAttribute('aria-label'))button.setAttribute('aria-label',this.dialog?.getAttribute('aria-label')||image.alt);
        button.addEventListener('click',()=>{
          if(!this.dialog||!large||typeof this.dialog.showModal!=='function')return;
          large.src=image.currentSrc||image.src;
          large.alt=image.alt||this.dialog.getAttribute('aria-label');
          large.width=image.naturalWidth||Number(image.getAttribute('width'))||1200;
          large.height=image.naturalHeight||Number(image.getAttribute('height'))||900;
          if(!this.dialog.open)this.dialog.showModal();
        },{signal});
      });
      close?.addEventListener('click',()=>this.dialog.close(),{signal});
      this.dialog?.addEventListener('click',event=>{
        if(event.target!==this.dialog)return;
        const rect=this.dialog.getBoundingClientRect();
        if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.dialog.close();
      },{signal});
      this.dialog?.addEventListener('close',()=>large?.removeAttribute('src'),{signal});
      const tabs=[...this.querySelectorAll('.cfxe-review-tabs button')];
      const reviews=this.querySelector('[id$="-reviews-panel"]');
      const faq=this.querySelector('[id$="-faq-panel"]');
      const selectTab=tab=>{
        const showFaq=tab.id.endsWith('-faq-tab');
        tabs.forEach(t=>{const active=t===tab;t.classList.toggle('cfxe-active',active);t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
        if(reviews){reviews.hidden=showFaq;reviews.style.removeProperty('display');}
        if(faq){faq.hidden=!showFaq;faq.style.removeProperty('display');}
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>selectTab(tab),{signal});
        tab.addEventListener('keydown',event=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();
          const target=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
          tabs[target].focus();selectTab(tabs[target]);
        },{signal});
      });
      if(tabs.length)selectTab(tabs[0]);
      const items=[...this.querySelectorAll('.cfxe-review-list article[data-review-page]')];
      const dots=[...this.querySelectorAll('.cfxe-review-dot')];
      const selectPage=(page,scroll)=>{
        items.forEach(item=>item.hidden=item.dataset.reviewPage!==page);
        dots.forEach(dot=>{
          const active=dot.dataset.reviewPage===page;
          dot.classList.toggle('cfxe-active',active);
          if(active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');
        });
        if(scroll){
          const first=items.find(item=>item.dataset.reviewPage===page);
          if(first){
            const header=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))||0;
            window.scrollTo({top:first.getBoundingClientRect().top+scrollY-header-24,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          }
        }
      };
      dots.forEach(dot=>dot.addEventListener('click',()=>selectPage(dot.dataset.reviewPage,true),{signal}));
      if(dots.length)selectPage(dots[0].dataset.reviewPage,false);
    }
    disconnectedCallback(){
      this.judgeObserver?.disconnect();this.judgeObserver=null;
      cancelAnimationFrame(this.startup);this.startup=0;
      if(this.dialog?.open)this.dialog.close();
      this.abort?.abort();this.abort=null;this.resize?.disconnect();
    }
  }
  customElements.define('mv-cubeflex-extras',CubeFlexExtras);
})();
